export const colors = [
  "#BEB692",
  "#354660",
  "#0E1619",
  "#BCC8C5",
  "#BEB692",
  "#354660",
  "#0E1619",
  "#BCC8C5",
  "#BEB692",
  "#354660",
];
